#import "../fragments/meeting-fragment.graphql"

mutation DuplicateMeeting($input: MeetingDuplicateInputFieldInput!) {
    meetingDuplicate(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
